export default {
  Base: {
    BaseContent: 'KnowledgeBase Content',
    monthAgeSegment: 'Month Age Segment',
    ApplicableLabels: 'Applicable Labels',
    addKnowledgeBase: 'Add KnowledgeBase',
    editKnowledgeBase: 'Edit KnowledgeBase',
    feedingPattern: 'Feeding Pattern'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/mmc/knowledgeBase.js